import { ResponseLSDto } from "@common/ict/model/interface/common";
import { AxiosInstance } from "axios";
import {
  GetICTVerifyCodeDto,
  GetPhoneCodeLSDto,
  LoginByVerifyCodeDto,
  LoginLSDto,
  RegisterUserLSDto,
  RegisterUserLSDtoNew,
  ResetPasswordLSDto,
  GetICTEmailVerifyCodeDto,
  FirstPasswordLSDto
} from "@common/ict/model/interface/login";
const url = "/api_gateway/uams_msa/v0.1";
const verifyCodeUrl = "zh-user/api/v1/verification";
const loginServiceUrl = "zh-user/console/v1/user";
export class ICTLoginApi {
  static doLogin(request: AxiosInstance, loginInfo: LoginLSDto) {
    return request.post<ResponseLSDto, ResponseLSDto>(
      `/zh-user/console/v1/user/pwd/login`,
      loginInfo
    );
  }
  static getLoginInfo(request: AxiosInstance) {
    return request.get<ResponseLSDto, ResponseLSDto>(
      `${url}/accounts/commands/loadinguser`
    );
  }
  // 获取验证图片
  static getImageCode(request: AxiosInstance) {
    return request.get<ResponseLSDto, ResponseLSDto>(
      `${url}/verifications/commands/loadingimagecode`,
      {
        headers: {
          noAuth: "true"
        }
      }
    );
  }
  // 获取手机验证码
  static getPhoneCode(request: AxiosInstance, info: GetPhoneCodeLSDto) {
    return request.post<ResponseLSDto, ResponseLSDto>(
      `${url}/verifications/commands/sendsmscode`,
      info
    );
  }
  // 注册
  static registerUser(request: AxiosInstance, info: RegisterUserLSDto) {
    return request.post<ResponseLSDto, ResponseLSDto>(
      `${url}/accounts/commands/register`,
      info
    );
  }
  // 重置密码
  static resetPassword(request: AxiosInstance, info: ResetPasswordLSDto) {
    return request.post<ResponseLSDto, ResponseLSDto>(
      `${url}/accounts/commands/resetpassword`,
      info
    );
  }
  // 第一次登录重置密码
  static firstPassword(request: AxiosInstance, info: FirstPasswordLSDto) {
    return request.post<ResponseLSDto, ResponseLSDto>(
      `zh-user/console/v1/user/first/reset/password`,
      info
    );
  }
  // 滑块验证
  static sliderLoginVerify(request: AxiosInstance, data: string) {
    return request.get(`/zh-user/api/v1/verification/code/query`, {
      params: {
        name: data
      }
    });
  }
  // 获取校验码
  static getVerifyCode(request: AxiosInstance) {
    return request({
      url: `${verifyCodeUrl}/code/query`,
      method: "GET"
    }).then(res => {
      return res.data;
    });
  }
  static pwdLogin(request: AxiosInstance, data) {
    return request({
      url: `${loginServiceUrl}/pwd/login`,
      method: "POST",
      data
    }).then(res => {
      return res;
    });
  }

  static getICTVerifyCode(request: AxiosInstance, data: GetICTVerifyCodeDto) {
    return request.post<ResponseLSDto, ResponseLSDto>(
      "zh-user/api/v1/user/send/verify/code",
      data
    );
  }
  // 获取邮箱验证码
  static getICTVerifyEmailCode(
    request: AxiosInstance,
    data: GetICTEmailVerifyCodeDto
  ) {
    return request.post<ResponseLSDto, ResponseLSDto>(
      "zh-user/api/v1/user/send/email_verify/code",
      data
    );
  }
  static loginByVerifyCode(request: AxiosInstance, data: LoginByVerifyCodeDto) {
    return request.post<ResponseLSDto, ResponseLSDto>(
      "zh-user/console/v1/user/code/login",
      data
    );
  }
  static registerByVerifyCode(
    request: AxiosInstance,
    data: RegisterUserLSDtoNew
  ) {
    return request.post<ResponseLSDto, ResponseLSDto>(
      "zh-user/api/v1/user/ict/register",
      data
    );
  }
  static checkSliderRes(request: AxiosInstance, data) {
    return request.post<ResponseLSDto, ResponseLSDto>(
      "zh-user/api/v1/verification/result",
      data
    );
  }
  // 注册时失去手机号焦点判断该手机号是否已经被注册
  static registerByVerifyPhone(request: AxiosInstance, data) {
    return Promise.resolve({ data: true, message: "成功", status: 4000200 });
    // return request.get<ResponseLSDto, ResponseLSDto>(
    //   `/zh-user/api/v1/user/query`,
    //   {
    //     params: data
    //   }
    // );
  }
  // 重置密码
  static resetUserPassword(request: AxiosInstance, data) {
    return request.post<ResponseLSDto, ResponseLSDto>(
      "zh-user/console/v1/user/reset/password",
      data
    );
  }

  // 退出登录
  static logOut(request: AxiosInstance) {
    return request.post<ResponseLSDto, ResponseLSDto>(
      "zh-user/console/v1/user/logout"
    );
  }
  // 第一次登录修改密码
  static firstSetPwd(request: AxiosInstance, data) {
    return request.post<ResponseLSDto, ResponseLSDto>(
      "zh-user/console/v1/user/first/reset/password",
      data
    );
  }
}

/*
url: `${loginServiceUrl}/sliding/block/query`,
    method: "GET",
    params: query
  }).then(res => {
    return res.data;
*/
